<template>
  <div 
    class="textfield-component"
  >
    <v-card-text
      class="common-textfield pa-0"
      :class="isSmallDevice ? 'small-device' : ''"
    >
      <v-col
        class="pa-0 form-label"
        cols="6"
        style="
          font-weight: bold !important;
          display: inline-flex !important;
          vertical-align: top !important;
          margin-top: 10px;
        "
        >{{ labelName }}
      </v-col>
      <v-col class="pa-0" style="display: inline-flex !important" cols="6">
        <v-text-field
          type="string"
          class="pa-0"
          v-model="commonTextField"
          :label="itemMessage"
          :disabled="!isClickable"
          :rules="createItemRules"
          :required="!notRequired"
          :maxlength="maxlength"
          clearable
          @input="handleTextInput"
          @clear="onClearTextInput"
        ></v-text-field>
      </v-col>
    </v-card-text>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  props: {
    value: String,
    labelName: String,
    isClickable: Boolean,
    itemMessage: String,
    notRequired: Boolean,
    isSmallDevice: Boolean,
    defaultValue: String,
    itemRules: Array,
    maxlength: Number,
  },
  data: () => {
    return {
      commonTextField: "",
    };
  },
  mounted() {
    if (this.defaultValue && this.defaultValue !== "") {
      this.commonTextField = this.defaultValue;
    }
  },
  methods: {
    handleTextInput() {
      if (this.commonTextField !== "" && this.commonTextField !== null) {
        this.$emit("set-text-value", this.commonTextField);
      } else {
        this.$emit("set-text-value", "");
      }
    },
    onClearTextInput() {
      this.$emit("set-text-value", "");
    }
  },
  computed: {
    createItemRules() {
      let rules = [v => !!v || this.$props.itemMessage];
      if(!this.$props.notRequired) {
        if(this.$props.itemRules) {
          rules = rules.concat(this.$props.itemRules);
        } 
        return rules;
      } else {
        return [];
      }
    }
  },
  watch: { 
    value: function(newVal, oldVal) { 
      this.commonTextField = newVal;
    }
  }
});
</script>

<style lang="css" scoped>
.textfield-component {
  width: 94%; 
  margin-left: 3% !important;
}
.common-textfield >>> .v-label {
  right: 0rem !important;
  left: auto !important;
  font-size: 0.85rem;
  max-width: 100% !important;
  color: #9e9e9e;
}
.common-textfield >>> .v-icon {
  font-size: 1.25rem !important;
}
.common-textfield >>> input {
  font-size: 0.9rem !important;
}
.common-textfield >>> .v-text-field input {
  font-size: 0.9rem;
  text-align: right;
}
.common-textfield >>> .v-input__slot:before {
  border-style: none !important;
}
.common-textfield >>> .v-messages__message {
  font-size: 0.8rem;
  text-align: right;
  float: right;
  margin-right: 0 !important;
}
.common-textfield >>> .v-input__slot:after {
  border-style: none !important;
}
.common-textfield >>> .v-text-field .v-label--active {
  display: none !important;
}
.common-textfield >>> .v-text-field__details {
  display: none !important;
}
.common-textfield.small-device >>> * {
  font-size: 0.8rem !important;
}
</style>
